define.alias("ember-truth-helpers/helpers/and", "calendar/helpers/and");